import { createClient } from '@supabase/supabase-js';

const supabaseUrl = 'https://tjltbozcxpbervkugceg.supabase.co';
const supabaseAnonKey = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InRqbHRib3pjeHBiZXJ2a3VnY2VnIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NzM4NjU5ODYsImV4cCI6MjA4OTQ0MTk4Nn0.hFDcBvAENeTXRCB261vedgfksKTLdwN5jQ70Xb1bQ20';

export const supabase = createClient(supabaseUrl, supabaseAnonKey);
